var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First-time homebuyer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 14.798H5.5V17.798H2.5V19.798H5.5V22.798H7.5V19.798H10.5V17.798H7.5V14.798ZM19.5 20.798V12.798H22.5L12.5 3.79803L2.5 12.798H7.5V10.988L12.5 6.48803L17.5 10.988V18.798H12.5C12.5 19.498 12.38 20.168 12.16 20.798H19.5Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 14.798H5.5V17.798H2.5V19.798H5.5V22.798H7.5V19.798H10.5V17.798H7.5V14.798Z",
    fill: "#14AA3C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario14);
export default __webpack_public_path__ + "static/media/Scenario14.eb93e13124ca484331274ead3f7bb14f.svg";
export { ForwardRef as ReactComponent };